import { render, staticRenderFns } from "./EditRoundTournament.vue?vue&type=template&id=1fd30c4a&scoped=true"
import script from "./EditRoundTournament.vue?vue&type=script&lang=js"
export * from "./EditRoundTournament.vue?vue&type=script&lang=js"
import style0 from "./EditRoundTournament.vue?vue&type=style&index=0&id=1fd30c4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd30c4a",
  null
  
)

export default component.exports